import { render, staticRenderFns } from "./OddOneOut.vue?vue&type=template&id=14f21095&scoped=true"
import script from "./OddOneOut.vue?vue&type=script&lang=ts"
export * from "./OddOneOut.vue?vue&type=script&lang=ts"
import style0 from "./OddOneOut.vue?vue&type=style&index=0&id=14f21095&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f21095",
  null
  
)

export default component.exports